// Pure helper for building the support "mailto:" URL. This module deliberately
// imports nothing (no Angular, no environment lookups) so it can be unit tested
// in the bare mocha harness — support-contact.ts (which wires the dialog to
// AlertController / ToastController and resolves the support address) re-uses it.

// Assemble the pre-filled "mailto:" URL from its already-resolved parts.
// Every value (incl. the support address) is passed in, so this stays pure and
// unit-testable. The caller (buildSupportMailtoUrl in support-contact.ts) gathers
// the runtime values — support address, subject, app version, user agent.
export function composeSupportMailtoUrl(parts: {
  supportEmail: string;
  subject: string;
  userEmail: string;
  appVersion: string;
  userAgent: string;
}): string {
  // build the body, joining the lines with pre-encoded CRLF (%0D%0A)
  const emailBody =
    `Here-goes-body%0D%0A%0D%0AUser login: ${parts.userEmail}` +
    `%0D%0AApp version: ${parts.appVersion}%0D%0ABrowser: ${parts.userAgent}`;
  return `mailto:${parts.supportEmail}?subject=${parts.subject}&body=${emailBody}`;
}
